export default "__VITE_ASSET__BEeHIp69__"